export type StrapiCommonType = {
    id: string;
    attributes: any;
};
